import { PartyPopper, Truck } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function TopAnnouncementBar() {
    const { t } = useTranslation();
    
    return (
        <div className="hidden md:flex justify-between items-center bg-surface dark:bg-dark text-dark dark:text-white px-4 py-1.5 text-[11px] lg:text-sm">
            <div className="flex items-center gap-2">
                <PartyPopper className="text-gold m-1" />
                <span>{t("navbar.announcement.welcome")}</span>
            </div>
            <div className="flex items-center gap-2">
                <Truck size={16} />
                <span>{t("navbar.announcement.discount")}</span>
            </div>
        </div>
    );
}
